export const selectorPeticioObtenirEstructuraEnCurs = state => state.estacio.formulari.peticioObtenirEstructuraEnCurs;



// WEBPACK FOOTER //
// ./src/selectors/selector_estacio_peticio_obtenir_estructura_en_curs.js